// extracted by mini-css-extract-plugin
export default {"notifications":"Notification_notifications__A4Oo7"};